<template>
  <div v-if="hasTiles" class="Testimonials">
    <TileDisplay
      :title="title"
      :tiles="items"
      type="testimonials"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import TileDisplay from '@cvo/ui/components/organisms/TileDisplay/TileDisplay.vue';
import type { TestimonialsProps } from './Testimonials.model';

const props = defineProps<TestimonialsProps>();

const hasTiles = computed(() => props.items && props.items.length > 0);
</script>

<style lang="scss">
@use '@cvo/ui/styles/design-system' as vars;

  @layer cvo-ui {
    .Testimonials {
      .TileDisplay-tile {
        background-color: var(--section-surface-color, #{vars.$molecules-tile-step-bg-color});
      }
    }
  }
</style>